module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"early-pomona-family\"-in-pomona-california-730a9e82e39ca1f72f79778810160bc0.png";